/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { BulbImageModule } from 'src/app/image/bulb-image.module';
import { BulbCommonModule } from '../common/bulb-common.module';
import { BulbCKEStateService } from './editor/services/bulb-cke-state.service';
import { EditorComponent } from './editor/editor.component';
import { PageEditorComponent } from './editor/page-editor/page-editor.component';
import { EditorDialogService } from './editor/services/editor-dialog.service';
import { CkeImageComponent } from './component/cke-image/cke-image.component';
/**
 * Our Angular Feature Module for our new Editor, CKEditor.
 */
@NgModule({
  declarations: [
    CkeImageComponent,
    EditorComponent,
    PageEditorComponent,
  ],
  exports: [
    CkeImageComponent,
    EditorComponent,
    PageEditorComponent,
  ],
  imports: [
    BulbCommonModule,
    BulbImageModule,
    CommonModule,
    CKEditorModule,
    CommonModule,
    FormsModule,
    TranslocoModule,
  ],
  providers: [
    BulbCKEStateService,
    EditorDialogService,
  ],
})
export class BulbCkeditorModule { }
